module.exports = __webpack_public_path__ + "img/logo1.7801f5c8.png";